import { type FC, useState } from 'react'
import classNames from 'classnames'
import { type SchedulingEventType } from '../../../../../models/Scheduling'
import { EventTypeImpactDialog } from '../../../../Scheduling/shared/EventTypeImpactDialog'
import styles from '../../../../Scheduling/shared/EventTypeList.module.scss'

interface StatusSegmentProps {
  eventType: SchedulingEventType
  disabled: boolean
  onChange: (isActive: boolean) => void
}

export const StatusSegment: FC<StatusSegmentProps> = ({ eventType, disabled, onChange }) => {
  const isActive = eventType.active
  const [isDeactivateOpen, setIsDeactivateOpen] = useState(false)

  const handleDeactivate = () => {
    if (isActive) {
      setIsDeactivateOpen(true)
    } else {
      onChange(false)
    }
  }

  const handleDeactivateConfirm = () => {
    setIsDeactivateOpen(false)
    onChange(false)
  }

  return (
    <div className='d-flex flex-column zocks-gap-0.5'>
      <div className='lead-small zocks-text-gray-600'>Status</div>
      <div className='d-flex gap-2 p-1 rounded-1 zocks-bg-color-gray-100'>
        <button
          type='button'
          disabled={disabled}
          className={classNames(
            'btn d-flex align-items-center justify-content-center zocks-gap-0.5 flex-grow-1 px-2 py-1 paragraph-small rounded-1',
            isActive ? 'border zocks-border-color-gray-300 zocks-bg-color-white zocks-text-gray-900' : 'border-0 zocks-text-gray-700',
          )}
          aria-pressed={isActive}
          onClick={() => onChange(true)}
        >
          <i className={classNames('bi bi-circle-fill zocks-text-success', styles.statusDot)} />
          Active
        </button>
        <button
          type='button'
          disabled={disabled}
          className={classNames(
            'btn d-flex align-items-center justify-content-center flex-grow-1 px-2 py-1 paragraph-small rounded-1',
            !isActive ? 'border zocks-border-color-gray-300 zocks-bg-color-white zocks-text-gray-900' : 'border-0 zocks-text-gray-700',
          )}
          aria-pressed={!isActive}
          onClick={handleDeactivate}
        >
          Inactive
        </button>
      </div>
      <div className='paragraph-small zocks-text-gray-700'>Available for users to add to their booking page.</div>
      {isDeactivateOpen ? (
        <EventTypeImpactDialog variant='deactivate' eventType={eventType} onConfirm={handleDeactivateConfirm} onCancel={() => setIsDeactivateOpen(false)} />
      ) : null}
    </div>
  )
}
